import logo from "@/assets/pi360-logo.png";

export function Logo({ className = "h-10" }) {
  return (
    <img
      src={logo}
      alt="PropertyInspect360 — Inspect, Document, Manage, Anywhere"
      data-testid="app-logo"
      className={`w-auto object-contain ${className}`}
    />
  );
}

const SEV = {
  minor: "bg-amber-100 text-amber-800 border border-amber-300",
  moderate: "bg-orange-100 text-orange-800 border border-orange-300",
  major: "bg-red-100 text-red-800 border border-red-300",
};
const SEV_LABEL = { minor: "Minor", moderate: "Moderate", major: "Major" };

export function SeverityBadge({ level }) {
  return (
    <span
      data-testid={`severity-badge-${level}`}
      className={`inline-flex items-center rounded-md px-2 py-0.5 font-display text-xs font-bold uppercase tracking-wider ${SEV[level] || SEV.minor} ${level === "major" ? "animate-pulse-subtle" : ""}`}
    >
      {SEV_LABEL[level] || level}
    </span>
  );
}

const STATUS = {
  open: "bg-sky-100 text-sky-800 border border-sky-300",
  in_progress: "bg-indigo-100 text-indigo-800 border border-indigo-300",
  resolved: "bg-emerald-100 text-emerald-800 border border-emerald-300",
};

export function StatusBadge({ status }) {
  const label = { open: "Open", in_progress: "In Progress", resolved: "Resolved" }[status] || status;
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold ${STATUS[status] || STATUS.open}`}>
      {label}
    </span>
  );
}
